import { createRef, Component } from "react";
import { graphql } from "gatsby";
import styles from "./media-gallery-block.module.less";
import UiPicture from "@rnb/ui-picture";
import UiLightbox from "@rnb/ui-lightbox";
import { Carousel, extract, isArray, EventAggregator, multipleClassNames } from "@parksandresorts/core";

export default class MediaGalleryBlock extends Component {
  constructor(props) {
    super(props);
    this.ref_lightbox = createRef();
    this.showLightBox = this.showLightBox.bind(this);
    this.lightboxListItems = this.transformMediaListToItems();
    this.carouselListItems = this.transformLightboxListItemsToCarouselListItems();
    this.isSingleItem = this.carouselListItems.length === 1;
  }

  componentDidMount() {
    this.lightboxRefElementHideAreaOnShow = document.body.parentNode;
  }

  transformMediaListToItems() {
    if (!isArray(this.props.mediaList)) {
      return [];
    }

    const mediaListItemsWithImages = this.props.mediaList.filter((mediaItem) => {
      const imageUrl = extract(mediaItem, "image.file.url", null);
      return imageUrl;
    });

    return mediaListItemsWithImages.map((mediaItem) => {
      return {
        type: mediaItem.youtubeUrl ? "youtube" : "image",
        url: extract(mediaItem, "image.file.url", null),
        youtubeUrl: mediaItem.youtubeUrl ? mediaItem.youtubeUrl : "",
        imageWidth: extract(mediaItem, "image.file.details.image.width", undefined),
        imageHeight: extract(mediaItem, "image.file.details.image.height", undefined),
        alt: extract(mediaItem, "image.description", ""),
      };
    });
  }

  getPicture(li) {
    if (!li) {
      return undefined;
    }

    return {
      id: this.props.contentful_id,
      src: `${li.url}?w=500&q=70`,
      alt: li.alt ? li.alt : "",
      loading: "lazy",
      decode: "async",
      width: li.imageWidth ? li.imageWidth : undefined,
      height: li.imageHeight ? li.imageHeight : undefined,
      sources: [
        {
          srcset: `${li.url}?w=800&q=70&fm=webp,`,
          type: "image/webp",
        },
        {
          srcset: `${li.url}?w=800&q=70`,
        },
      ],
    };
  }

  transformLightboxListItemsToCarouselListItems() {
    return this.lightboxListItems.map((item, i) => {
      return (
        <button
          key={i}
          className={styles.mediaGallery__listItemBtn}
          onClick={(e) => this.showLightBox(this.lightboxListItems, i, e)}
        >
          {item && <UiPicture {...this.getPicture(item)} />}

          {item.type === "youtube" ? (
            <div className={[styles.mediaGallery__playIcon, "icon-play_circle_filled"].join(" ")}></div>
          ) : (
            ""
          )}
        </button>
      );
    });
  }

  showLightBox = (items, index, event) => {
    this.ref_lightbox.current.onShow(items, index, event.target);
    const imageNumber = index + 1;
    EventAggregator.publish("trackEvent", {
      category: "Media Gallery",
      action: "Opened",
      label: "Image " + imageNumber,
    });
  };

  render() {
    return (
      <section
        className={["block block--floating block--max-width", styles.mediaGallery].join(" ")}
        data-contentful-id={this.props.contentful_id}
      >
        <div className={styles.mediaGallery__outerWrapper}>
          {this.props.title && <h2 className={[styles.mediaGallery__title, "h2"].join(" ")}>{this.props.title}</h2>}
          <div className={styles.mediaGallery__innerWrapper}>
            <Carousel
              classNameListItem={multipleClassNames(styles.carouselListItem, this.isSingleItem && styles.singleItem)}
              navDots={true}
            >
              {this.carouselListItems}
            </Carousel>
          </div>
        </div>
        <UiLightbox
          refElementHideAreaOnShow={this.lightboxRefElementHideAreaOnShow}
          hideAreaOnShowClassName="html__ui-lightbox--active"
          iconCloseBtn={{ icon: "icon-close", align: "center" }}
          portalId="___gatsby"
          ref={this.ref_lightbox}
        />
      </section>
    );
  }
}

export const fragmentMediaGalleryBlock = graphql`
  fragment MediaGalleryBlock on ContentfulMediaGalleryBlock {
    contentful_id
    id
    title
    mediaList {
      image {
        ...Asset
      }
      youtubeUrl
    }
  }
`;
